export default "__VITE_ASSET__B7DQ8qXF__"